import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  buttonContainer: {
    display: 'flex',
    gap: '16px',
  },
  checkboxSection: {
    backgroundColor: '#f9fafb',
    borderRadius: '4px',
    padding: '14px',
    alignSelf: 'flex-start',
    width: '900px',
    '& label': {  
        color: '#000000ff',
    },
  },
  disabledCheckbox: {
    '& .fui-Checkbox__indicator': {
      backgroundColor: '#d1d5db', 
      
    },
  },


});